import * as plotUtil from '../plot_util'

export default function (coordinates) {
    if (coordinates.length < 3) return [coordinates];
    let [center,pnt2,pnt3] = coordinates;
    let radius = plotUtil.distance(plotUtil.wgsToMercator(pnt2), plotUtil.wgsToMercator(center));
    let startAngle = plotUtil.getAzimuth(plotUtil.wgsToMercator(pnt2), plotUtil.wgsToMercator(center));
    let endAngle = plotUtil.getAzimuth(plotUtil.wgsToMercator(pnt3), plotUtil.wgsToMercator(center));
    let pList = plotUtil.getArcPoints(plotUtil.wgsToMercator(center), radius, startAngle, endAngle);
    pList.push(center);
    return [pList];
}